import { redirectToEmailVerification, redirectToLoginSignin } from "../auth/internal/redirects";
import { ExtendedAxiosError, setUpAxios as setUpAxiosCore } from "./axiosHelper";

export const setUpAxios = (errorPipes?: ((error: ExtendedAxiosError) => Promise<never> | undefined)[]) => {
  setUpAxiosCore(redirectToLoginSignin, [isEmailNotVerifiedError, ...(errorPipes ?? [])]);
};

function isEmailNotVerifiedError(axiosError: ExtendedAxiosError): Promise<never> | undefined {
  if (axiosError.response?.status === 400) {
    const apiResponse = axiosError.response.data as { Error: { Type: string } };
    if (apiResponse.Error?.Type === "EmailNotVerified") {
      redirectToEmailVerification();
      return Promise.reject(new Error("Email not verified"));
    }
  }
  return undefined;
}
